import * as api from './api';

const noopDocument = true;

export { api, noopDocument };
